<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>基金</a-breadcrumb-item>
      <a-breadcrumb-item>Structure Chart</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="notice">请在下方搜索框中查询您需要查看的基金、项目、LP的名称，点击进入Strcture Chart页面查看</div>
    <div class="container">
      <div class="search-wrapper">
        <a-auto-complete
          class="global-search"
          size="large"
          style="width: 100%"
          placeholder="可搜索基金/项目/LP"
          option-label-prop="title"
          @select="onSelect"
          @search="handleInput"
          ref="auto"
        >
          <template slot="dataSource">
            <a-select-option v-for="item in optionList" :key="item.name" :title="item.name" :data-item="item">
              {{ item.name }}
            </a-select-option>
          </template>
          <a-input @focus="search">
            <a-select slot="addonBefore" v-model="selectedType" @focus="clearList" :class="['select-cus']" :showArrow="true">
              <a-select-option :value="item" v-for="item in typeList" :key="item">
                {{ item }}
              </a-select-option>
            </a-select>
            <a-icon type="search" slot="suffix" @click="search" />
          </a-input>
        </a-auto-complete>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import { querySimple } from '@/api/deal.js';

const typeMap = {
  全部: 0,
  只搜基金: 1,
  只搜LP: 2,
  只搜公司: 3
};
export default {
  data() {
    return {
      typeList: ['全部', '只搜基金', '只搜LP', '只搜公司'],
      selectedType: '全部',
      keyword: '',
      optionList: []
    };
  },
  watch: {
    selectedType() {
      this.search();
    }
  },
  methods: {
    search(e) {
      this.$ga.gaUploadCustomEvent('北冥-Structure chart-搜素');
      let { selectedType, keyword } = this;
      keyword = keyword.trim();
      if (keyword) {
        querySimple({
          type: typeMap[selectedType] || 0,
          name: keyword
        })
          .then(res => {
            let { data } = res || {};
            if (data && data.length) {
              this.optionList = data;
            } else {
              this.clearList();
            }
          })
          .catch(e => {
            this.clearList();
            this.$message.error(e.message);
          });
      } else {
        this.clearList();
      }
    },
    handleInput(val) {
      this.keyword = val;
      this.search();
    },
    onSelect(val) {
      this.keyword = val;
      let selectedItem = this.optionList.find(item => item.name === val);
      let { type, id } = selectedItem;
      window.open(`${window.location.origin}/finance/fundManage/fundChart?type=${type}&id=${id}`);
    },
    clearList() {
      this.optionList = [];
    },
    dropTypeList() {
      this.$refs.auto.blur();
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 60%;
  margin-top: 30px;
}
.notice {
  margin-top: 30px;
  font-size: 15px;
}

.search-wrapper {
  width: 100%;
}
</style>

<style lang="less">
.select-cus {
  padding: 0 11px;
  width: 100px;
}

//select组件箭头未展示 手动添加
.select-cus.ant-select-show-arrow {
  position: relative;
  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border: 5px solid transparent;
    border-top: 5px solid rgba(0, 0, 0, 0.65);
    position: absolute;
    right: 10px;
    top: 17px;
  }
}
.ant-select-open.select-cus.ant-select-show-arrow {
  position: relative;
  &::after {
    content: '';
    width: 10px;
    height: 10px;
    border: 5px solid transparent;
    border-bottom: 5px solid rgba(0, 0, 0, 0.65);
    position: absolute;
    right: 10px;
    top: 12px;
  }
}
</style>
